import { render } from "./ItemLedger_list.vue?vue&type=template&id=f2a577a2"
import script from "./ItemLedger_list.vue?vue&type=script&lang=js"
export * from "./ItemLedger_list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__